/**
 * name: Input's name    string
 * containerStyle: Input's container style    object
 * style: Input's style    object
 * type: Input's type    string
 * inputMode: Input's input mode    string
 * placeholder: Input's placeholder    string
 * value: Input's value    state (필수)
 * onChange: Input's change event    function (필수)
 * onClick: Input's click event    function (필수)
 * onKeyDown: Input's key down event    function (필수)
 * disabled: Input's disabled    boolean
 *
 */

import React from "react";

function BasicInput({
  name,
  containerStyle,
  style,
  type,
  inputMode,
  placeholder,
  value,
  labelStyle,
  onChange = (e) => {
    return false;
  },
  onClick = (e) => {
    return false;
  },
  onKeyDown = (e) => {
    return false;
  },
  disabled,
}) {
  const InputChange = (e) => {
    onChange(e);
  };

  const InputClick = (e) => {
    onClick(e);
  };

  const InputKeyDown = (e) => {
    onKeyDown(e);
  };

  return (
    <div className="input_set" style={containerStyle}>
      {name === "" ? null : <label style={labelStyle}>{name}</label>}
      <input
        style={style}
        type={type}
        inputMode={inputMode}
        placeholder={placeholder}
        value={value}
        onChange={InputChange}
        onClick={InputClick}
        onKeyDown={InputKeyDown}
        disabled={disabled}
        autoComplete="off"
      />
    </div>
  );
}

BasicInput.defaultProps = {
  name: "",
  type: "text",
  disabled: false,
};

export default BasicInput;
